import { orthogonalMax, orthogonalMin, pixelRatio2d, wallAdsorbDistance } from '@/editor/math/const';
import { IPoint2d } from '@/editor/math/IPoint2d';
import editorEvent, { EditorEventName } from '@/editor/event/editorEvent';
import { globalStores } from '@/editor/stores';
import { LineSeg2d } from '@/editor/math/LineSeg2d';

// 正交吸附线计算器
export class AdsorbOrthogonalLine {
  private _horizontalLineStart: IPoint2d;
  private _horizontalLineEnd: IPoint2d;
  private _verticalLineStart: IPoint2d;
  private _verticalLineEnd: IPoint2d;

  private _horizontalAdsorbSeg?: LineSeg2d;
  private _verticalAdsorbSeg?: LineSeg2d;
  private _lock: boolean;
  private _minAdsorbDistance: number = wallAdsorbDistance;

  constructor(minAdsorbDistance: number = wallAdsorbDistance) {
    this._horizontalLineStart = { x: 0, y: 0 };
    this._horizontalLineEnd = { x: 0, y: 0 };
    this._verticalLineStart = { x: 0, y: 0 };
    this._verticalLineEnd = { x: 0, y: 0 };
    this._lock = false;

    editorEvent.on(EditorEventName.VIEW2D_CHANGE, () => {
      this._minAdsorbDistance = Math.min(
        minAdsorbDistance / globalStores.editorStateStore.sceneInfo.scene2d.camera.zoom,
        minAdsorbDistance
      );
    });
  }

  clear() {
    this._lock = true;
    this._horizontalLineStart = { x: 0, y: 0 };
    this._horizontalLineEnd = { x: 0, y: 0 };
    this._verticalLineStart = { x: 0, y: 0 };
    this._verticalLineEnd = { x: 0, y: 0 };
  }

  get horizontalAdsorbSeg() {
    return this._horizontalAdsorbSeg;
  }

  get verticalAdsorbSeg() {
    return this._verticalAdsorbSeg;
  }

  updateOrthogonalLine(point: IPoint2d) {
    this._lock = false;
    this._horizontalLineStart = { x: orthogonalMin * pixelRatio2d, y: point.y };
    this._horizontalLineEnd = { x: orthogonalMax * pixelRatio2d, y: point.y };
    this._horizontalAdsorbSeg = new LineSeg2d(this._horizontalLineStart, this._horizontalLineEnd);

    this._verticalLineStart = { x: point.x, y: orthogonalMin * pixelRatio2d };
    this._verticalLineEnd = { x: point.x, y: orthogonalMax * pixelRatio2d };
    this._verticalAdsorbSeg = new LineSeg2d(this._verticalLineStart, this._verticalLineEnd);
  }

  orthogonalAdsorbResult(point: IPoint2d) {
    let horizontalAdsorbResult = false,
      verticalAdsorbResult = false;
    if (this._lock) {
      return { horizontalAdsorbResult, verticalAdsorbResult };
    }
    if (this._horizontalAdsorbSeg) {
      const horizontalDistance = this._horizontalAdsorbSeg.pointToLineDistance({
        x: point.x,
        y: point.y
      });
      horizontalAdsorbResult = horizontalDistance < this._minAdsorbDistance;
    }

    if (this._verticalAdsorbSeg) {
      const verticalDistance = this._verticalAdsorbSeg.pointToLineDistance({
        x: point.x,
        y: point.y
      });

      verticalAdsorbResult = verticalDistance < this._minAdsorbDistance;
    }

    return { horizontalAdsorbResult, verticalAdsorbResult };
  }

  pointOnHorizontalLine(point: IPoint2d) {
    const projectPoint = this._horizontalAdsorbSeg?.getPointProjectOnLine(point);

    return projectPoint;
  }

  pointOnVerticalLine(point: IPoint2d) {
    const projectPoint = this._verticalAdsorbSeg?.getPointProjectOnLine(point);

    return projectPoint;
  }

  setMinAdsorbDistance(distance: number) {
    this._minAdsorbDistance = distance;
  }
}
